import { useState } from "react";
import { Link } from "react-router-dom";
import { FaPlus } from "../../assets/icons/vander";
import { SecretaryLayout } from "../Layout";
import { AddShiftProcedureModal } from "../components/work_management/modals";
import { ShiftProcedureTable } from "../components/work_management/tables";
import {
  ShiftProcedureFilterForm,
  ShiftProcedurePagination,
} from "../components/work_management/forms";

export const RegisterShiftProcedurePage = () => {
  // Datos de hooks ----------------------------------------//
  // States ------------------------------------------------//
  const [isAddShiftProcedureModal, setIsAddShiftProcedureModal] =
    useState(false);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <>
      <SecretaryLayout>
        <div className="container-fluid">
          <div className="layout-specing">
            <div className="row">
              <div className="col-xl-9 col-md-6">
                <h5 className="mb-0">Registrar Procedimientos</h5>

                <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                  <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                    <li className="breadcrumb-item">
                      <Link to="/secretary/dashboard">gosafe</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Registrar Procedimientos
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="col-xl-3 col-md-6 mt-4 mt-md-0 text-md-end">
                <button
                  className="btn btn-icon btn-pills btn-primary btn-lg"
                  onClick={() => setIsAddShiftProcedureModal(true)}
                >
                  <FaPlus className="icons" />
                </button>
              </div>
            </div>

            <div className="mt-4">
              <ShiftProcedureFilterForm />
            </div>

            <div className="mt-4">
              <ShiftProcedurePagination />
            </div>

            <div className="mt-4">
              <ShiftProcedureTable />
            </div>
          </div>
        </div>
      </SecretaryLayout>

      <AddShiftProcedureModal
        isOpen={isAddShiftProcedureModal}
        setIsOpen={setIsAddShiftProcedureModal}
      />
    </>
  );
};
